import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: 'img[appImgSrcFallback]' // Apply this directive to <img> tags with a appImgSrcFallback attribute
})
export class ImgSrcFallbackDirective {

  constructor(private el: ElementRef) { }

  @HostListener('error')
  onError() {
    const imageElement: HTMLImageElement = this.el.nativeElement;
    imageElement.src = 'https://placehold.co/250x250?font=roboto&text=' + (imageElement.alt || imageElement.title || 'CO'); // Provide a very last resort default
    imageElement.onerror = null; // Prevent infinite loop
  }
}
